import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcTab, IExcTab} from 'exc-tab';
import {ExcListConfig} from 'exc-controls';
import {ExcProgbarData} from '../../app-exc-progbar/app-exc-progbar.component';
import {ExcIndicatorData} from '../../app-exc-indicator/app-exc-indicator.component';
import {ModalNewAuditComponent} from '../../modals/modal-new-audit/modal-new-audit.component';
import {ModalDealerEditComponent} from '../../modals/modal-dealer-edit/modal-dealer-edit.component';
import {DatePipe, CurrencyPipe} from '@angular/common';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcSigninService} from 'exc-signin';
import {AuditReviewComponent} from '../../audit-review/audit-review.component';
import {ModalReviewFinsihComponent} from '../../modals/modal-review-finsih/modal-review-finsih.component';
import {ModalYesNoComponent} from '../../modals/modal-yes-no/modal-yes-no.component';
import {AuditActionService} from '../../audit-action-service.service';

@Component({
  selector: 'app-provider-audit-details',
  templateUrl: './provider-audit-details.component.html',
  providers: [CurrencyPipe, DatePipe],
  styles: []
})

export class ProviderAuditDetailsComponent extends ExcTranslation implements OnInit, IExcTab {
  @ViewChild('menuPopup') menuPopup;
  Data: any;
  data = {Header: {}, Inventory: [], Charts: [], Attachments: [], Results: [], ProgBarReview: [], ProgBarAttachments: [], GroupAudits: [], ReviewResults: [], Protocol: []};
  tabinstance: any;
  attachmentlistconfig: ExcListConfig = new ExcListConfig();
  groupAuditListConfig: ExcListConfig = new ExcListConfig();
  logListconfig: ExcListConfig = new ExcListConfig();
  progbarBalanceParts: ExcProgbarData[] = [];
  progbarCurrentBalance: ExcProgbarData[] = [];
  indicatorData: ExcIndicatorData[] = [];
  totalClaims = 0;
  level = 1;
  searchValueInventory: string = null;
  searchValueAttachments: string = null;
  isLoading = true;

  constructor(private aas: AuditActionService, private excRest: ExcRestService, private datePipe: DatePipe, private currencyPipe: CurrencyPipe, public excDss: DefaultSettingsService, public excSec: ExcSigninService) {
    super();
    const _self = this;
    _self.attachmentlistconfig.selectionMode = 'none';
    _self.attachmentlistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.attachmentlistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValueAttachments = searchValue || '';
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnPageChanged = (pageNo, event1) => {
      _self.attachmentlistconfig.paging.pagingPage = pageNo;
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnRefresh = () => {
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnDetailLink = (item, event?) => {
      // new ExcTab(item.DealerName, DealerDetailsComponent, item, item.DealerID, {
      //   Unique: true, ReloadParent: function () {
      //     // _self.initialLoad();
      //   }
      // }, true).Open();
    };
    _self.groupAuditListConfig.selectionMode = 'none';
    _self.groupAuditListConfig.OnDetailLink = (item, event?) => {
      new ExcTab(item.DealerName, ProviderAuditDetailsComponent, item, item.AuditID, {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
        }
      }, true).Open();
    };
  }
  openStock(e) {
    const _self = this;
    new ExcTab(this.data.Header['DealerName'] + ' - ' + this.data.Header['AuditID'], AuditReviewComponent, this.data.Header, this.data.Header['AuditID'] + '-Bestand' , {
      Unique: true, ReloadParent: function () { _self.partialLoad(); }
    }, true).Open();
    this.hideMenuPopup(e);
  }
  getDate(x, fmt = 'FormatDate')  {
    if (x === undefined || x === null) {
      return '';
    }
    return this.datePipe.transform(x, this.getGlobal(fmt));
  }
  ngOnInit() {
    this.initialLoad();
  }
  getResultClass(r) {
    if (r.IsFinding === true) {
      if (r.IsCritical === true) {
        return 'th-danger';
      } else {
        return 'th-warning';
      }
    } else {
      return 'th-secondary';
    }
  }
  getReviewResultClass(r) {
    if (r.Code === null) {
      return 'th-secondary';
    }
    if (r.IsOk === true) {
      return 'th-success';
    } else {
      if (r.IsCritical === true) {
        return 'th-danger';
      } else {
        return 'th-warning';
      }
    }
  }
  getProgbarData(container: string) {
    const x: ExcProgbarData[] = [];
    if (this.data[container]['Open']) {
      x.push(new ExcProgbarData(this.data[container]['Open'], this.getGlobal('Open'), '#1b477f', 'white', 'text', []));
    }
    if (this.data[container]['Ok']) {
      x.push(new ExcProgbarData(this.data[container]['Ok'], this.getGlobal('CheckedOk'), '#449d44', 'white', 'text', []));
    }
    if (this.data[container]['NOk']) {
      x.push(new ExcProgbarData(this.data[container]['NOk'], this.getGlobal('CheckedNOk'), '#F49306', 'white', 'text', []));
    }
    if (this.data[container]['Critical']) {
      x.push(new ExcProgbarData(this.data[container]['Critical'], this.getGlobal('CheckedCritical'), '#c9302c', 'white', 'text', []));
    }
    return x;
  }
  closeReview() {
    const _self = this;
    const rating = null;
    const modalSize = this.excDss.MandantSettings['ReviewRating'] && this.excDss.MandantSettings['ReviewRating'] !== null ? 'xl' : 'm';
    /* if (this.excDss.MandantSettings['ReviewRating'] !== undefined && this.excDss.MandantSettings['ReviewRating'] !== null) {*/
    ExcCoreModule.showModal(ModalReviewFinsihComponent, null, modalSize, null, false, null).subscribe( ret => {
      if (ret && ret.proceed === true) {
        _self.closeReviewAPI(ret.ReviewRating , ret.Comment );
      }
    });
    /* } else {
       ExcCoreModule.showModal(ModalYesNoComponent, null, 's', {Header: _self.getGlobal('CloseReviewHeader'), Message: _self.getGlobal('CloseReviewBody')}, false, null).subscribe( ratingSelected => {
         if (ratingSelected && ratingSelected.proceed === true) {
           _self.closeReviewAPI(null);
         }
       });
     }*/
  }
  closeReviewAPI(ratingSelected?: string , Comment?: string) {
    const _self = this;
    const url = _self.excRest.computeUrl('ReviewU_Finish', {AuditID: _self.Data.AuditID });
    _self.excRest.post(url, {ReviewRating: ratingSelected, ReviewUPT: null , Comment: Comment}, {}).subscribe(ret => {
      this.initialLoad();
    });
  }
  reloadAttachments() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditAttachmentR_List', {AuditID: this.Data.AuditID, fts: this.searchValueAttachments == null ? '' : this.searchValueAttachments});
    const mi = this.attachmentlistconfig.GetMetaInfo();
    _self.attachmentlistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Attachments = ret.data;
        _self.attachmentlistconfig.paging = ret.paging;
        _self.attachmentlistconfig.isLoading = false;
      }
    });
  }
  partialLoad() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditR_PartialReview', {AuditID: this.Data.AuditID});
    _self.attachmentlistconfig.isLoading = true;
    _self.excRest.get(url, {}).subscribe(ret => {
      if (ret) {
        _self.data = ret.data;
        _self.attachmentlistconfig.paging = ret.paging.Attachments;
        _self.attachmentlistconfig.isLoading = false;
      }
    });
  }
  initialLoad () {
    const _self = this;
    _self.isLoading = true;
    const url = _self.excRest.computeUrl('Provider_AuditR_Summary', {AuditID: this.Data.AuditID});
    _self.attachmentlistconfig.isLoading = true;
    _self.excRest.get(url, {}).subscribe(ret => {
      if (ret) {
        _self.data = ret.data;
        _self.attachmentlistconfig.paging = ret.paging.Attachments;
        _self.attachmentlistconfig.isLoading = false;
        _self.isLoading = false;
        for (const a of _self.data.GroupAudits) {
          const att: ExcProgbarData[] = [];
          att.push(new ExcProgbarData(a.AttachmentsOpen, this.getGlobal('Open'), '#1b477f', 'white', 'text', []));
          att.push(new ExcProgbarData(a.AttachmentsOk, this.getGlobal('CheckedOk'), '#449d44', 'white', 'text', []));
          att.push(new ExcProgbarData(a.AttachmentsNotOk, this.getGlobal('CheckedNOk'), '#c9302c', 'white', 'text', []));
          a['ProgBarAttachments'] = att;

          const rev: ExcProgbarData[] = [];
          rev.push(new ExcProgbarData(a.InventoryIsNotCleared, this.getGlobal('Open'), '#1b477f', 'white', 'text', []));
          rev.push(new ExcProgbarData(a.InventoryClearedOk, this.getGlobal('CheckedOk'), '#449d44', 'white', 'text', []));
          rev.push(new ExcProgbarData(a.InventoryClearedNotOk, this.getGlobal('CheckedNOk'), '#F49306', 'white', 'text', []));
          rev.push(new ExcProgbarData(a.InventoryClearedCritical, this.getGlobal('CheckedCritical'), '#c9302c', 'white', 'text', []));
          a['ProgBarReview'] = rev;

        }
      }
    });
  }
  auditAction(action) {
    const _self = this;
    switch (action) {
      case 'comment':
        this.aas.SelfcheckComment(_self.data.Header['AuditID'], _self.data.Header['AuditScComment']).subscribe(ret => {
          if (ret.Result === true) {
            Object.assign(_self.data.Header, ret.Data);
          }
        });
        break;
      case 'cancel':
        this.aas.Cancel(_self.data.Header['AuditID']).subscribe(ret => { if (ret.Result === true) { _self.initialLoad(); }});
        break;
      case 'pin':
        this.aas.ChangePin(_self.data.Header['AuditID']).subscribe(r => {});
        break;
      case 'extend':
        this.aas.Extend(_self.data.Header['AuditID']).subscribe(ret => { if (ret.Result === true) { _self.initialLoad(); }});
        break;
      case 'resend':
        this.aas.ResendCode(_self.data.Header['AuditID'], _self.data.Header['DealerMail']).subscribe(ret => {});
        break;
      case 'remoteclose':
        this.aas.RemoteClose(_self.data.Header['AuditID'], _self.data.Header['ScItemsDone'], _self.data.Header['ScItemsTotal']).subscribe(ret => { _self.initialLoad(); });
        break;
      default:
        break;
    }
  }

  getAuditReport(e) {
    const url = this.excRest.computeUrl('AuditR_Report', {AuditID: this.Data.AuditID});
    window.open(url, '_blank');
    this.hideMenuPopup(e);
  }
  getInventoryReport(e) {
    const url = this.excRest.computeUrl('AuditInventoryR_Export', {AuditID: this.Data.AuditID});
    window.open(url, '_blank');
    this.hideMenuPopup(e);
  }
  showMenuPopup(event) {
    this.menuPopup.show(event);
  }
  hideMenuPopup(event) {
    this.menuPopup.hide(event);
  }
}
